import { render, staticRenderFns } from "./WineDetailOverlay.vue?vue&type=template&id=b6da6ecc"
import script from "./WineDetailOverlay.vue?vue&type=script&lang=js"
export * from "./WineDetailOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports